import { initErrorTracking } from '../utils/errorTracking'

/**
 * Initialize all Firebase services and tracking
 */
export const initializeFirebase = () => {
    // Initialize error tracking
    const cleanupErrorTracking = initErrorTracking()

    return () => {
        cleanupErrorTracking()
    }
}

export default initializeFirebase